import { ShipmentStatus, useGetGroupByIdSuspense } from '@uturn/api/v1';
import { useShipmentsSearchStore } from '@uturn/portal/store/shipments/shipments-search';
import { useContext, useEffect, useMemo, useState } from 'react';
import { ShipmentGroupDetailContext } from '../providers/shipment-group-detail';
import { ShipmentsList } from './shipment-list';
import type { ShipmentsProps } from './shipment-page';

export const GroupedShipments = ({
	shipmentsParams,
	details,
	EmptyState,
	hasQuotes,
}: ShipmentsProps) => {
	const { totalShipments, setPagination } = useShipmentsSearchStore();
	const [page, setPage] = useState(0);
	const { groupId, setGroupName } = useContext(ShipmentGroupDetailContext);

	const { data: shipments, queryKey } = useGetGroupByIdSuspense(
		Number(groupId),
		{
			...shipmentsParams,
			page: page.toString(),
		},
		{
			query: {
				select: (data) => {
					setGroupName(data.data.name ?? '');
					return data.data.shipments;
				},
			},
		},
	);

	const quoteCount =
		hasQuotes && shipments && Array.isArray(shipments.data)
			? shipments.data.filter((s) => s.status === ShipmentStatus.QUOTED).length
			: 0;

	const pageSize = useMemo(
		() => shipments?.pageSize, // Rows on page
		[shipments?.totalElements],
	);

	useEffect(() => {
		setPagination(shipments?.totalElements, pageSize);
	}, [shipments?.totalElements, pageSize, setPagination]);

	if (totalShipments === 0) {
		return <EmptyState />;
	}

	return (
		<ShipmentsList
			shipments={shipments?.data ?? []}
			page={page}
			setPage={setPage}
			parentQueryKey={queryKey}
			details={details}
			hasQuotes={quoteCount > 0}
		/>
	);
};
